var _templateObject, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import styled from '@emotion/styled';
import MUISvgIcon, { svgIconClasses } from '@mui/material/SvgIcon';
import * as React from "react";
var SvgIcon = styled(MUISvgIcon)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &.", " {\n    width: ", ";\n    height: ", ";\n    color: ", ";\n    stroke-width: 1px;\n    vector-effect: non-scaling-stroke;\n  }\n"])), svgIconClasses.root, function (_ref) {
  var size = _ref.size,
    theme = _ref.theme;
  return size && theme.size[size];
}, function (_ref2) {
  var size = _ref2.size,
    theme = _ref2.theme;
  return size && theme.size[size];
}, function (_ref3) {
  var color = _ref3.color,
    theme = _ref3.theme;
  return color && theme.color[color];
});
var SvgUnaIcon = function SvgUnaIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#una-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M22.5 44.999c-9.941 0-18-9.402-18-21s8.059-21 18-21h3v42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#una-icon_svg__b)",
    d: "M22.5 44.999c-9.941 0-18-9.402-18-21s8.059-21 18-21h3v42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#una-icon_svg__c)",
    d: "M7.5 23.999c0 11.598 8.059 21 18 21s18-9.402 18-21-8.059-21-18-21-18 9.402-18 21"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#una-icon_svg__d)",
    d: "M7.5 23.999c0 11.598 8.059 21 18 21s18-9.402 18-21-8.059-21-18-21-18 9.402-18 21"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M6 23.999c0 12.201 8.522 22.5 19.5 22.5S45 36.2 45 23.999s-8.522-22.5-19.5-22.5S6 11.798 6 23.999m19.5 21c-9.941 0-18-9.402-18-21s8.059-21 18-21 18 9.402 18 21-8.059 21-18 21",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15,
    cy: 18,
    fill: "#000",
    rx: 15,
    ry: 18,
    transform: "matrix(-1 0 0 1 40.5 5.999)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m29.052 11.999-.442 1.639 6.64 5.62v7.316l-13.806 3.972 5.77-.58 4.26 3.274V36l-12.241-4.748v-5.89l5.168-2.309 7.312 2.488-5.432-3.267-4.065-1.076-3.744-1.404-1.222-3.499.712-.964 1.86-.222.017-.003 4.93-2.928z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M22.5 47.999h3c12.015 0 21-11.196 21-24s-8.985-24-21-24h-3c-12.015 0-21 11.196-21 24s8.985 24 21 24m0-3h3c9.941 0 18-9.402 18-21s-8.059-21-18-21h-3c-9.941 0-18 9.402-18 21s8.059 21 18 21",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "una-icon_svg__b",
    x1: 21.375,
    x2: 1.581,
    y1: 2.999,
    y2: 31.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D88EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#A8BCF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#B2F5CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FDDDB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FD8ACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ACF1D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "una-icon_svg__c",
    x1: 43.5,
    x2: 1.798,
    y1: 2.999,
    y2: 39.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395,
    stopColor: "#293E51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "una-icon_svg__d",
    x1: 7.5,
    x2: 47.709,
    y1: 44.999,
    y2: 10.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D88EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#A8BCF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#B2F5CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FDDDB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FD8ACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ACF1D4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "una-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  }))))));
};
export default SvgUnaIcon;